import { mergeMap } from 'rxjs/operators';
import { getDocumentUploadPresignedURLAction } from '../actions/GetDocumentUploadPresignedURL';

export default ({ actionType }) => {
  const epic = action$ =>
    action$.ofType(actionType).pipe(
      mergeMap(action => {
        const originalPayload = action.payload;
        const { presignedURLPayload } = originalPayload;
        return [
          getDocumentUploadPresignedURLAction({
            ...originalPayload,
            body: { ...presignedURLPayload },
          }),
        ];
      }),
    );
  return epic;
};
